"use strict";

exports.__esModule = true;
exports.OpenReportActionElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _DeviceContext = require("../../Device/DeviceContext");
var _System = require("../../../System");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Provides a function to a render prop which opens the report
 * screen for the selected device.
 */
var OpenReportActionElement = exports.OpenReportActionElement = (0, _reactRouterCompat.withRouter)(function (props) {
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var getURL = function getURL() {
    var id = props.reportID;
    return (0, _System.getScreenURL)("Report", {
      id: id
    }, {
      device: device.uuid
    });
  };
  var invoke = function invoke() {
    props.navigate(getURL());
  };
  var childProps = {
    getURL: getURL,
    invoke: invoke
  };
  return props.children(childProps);
});